const SEPARATOR = ',';

export const downloadBlob = (blob, fileName = 'grid-data.csv') => {
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  link.style.position = 'absolute';
  link.style.visibility = 'hidden';

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
};

export const reactDataGridExportCSV = (gridRef, fileName) => {
  const columns = gridRef.current.visibleColumns;

  const header = columns.map((c) => c.header).filter(header => header !== 'Actions').join(SEPARATOR);
  const rows = gridRef.current.data.map((data) => columns.filter(c => c.id !== 'actions' ).map((c) => ((data[c.id] === undefined || data[c.id] === null) ? '' : data[c.id]).toString().replace('true', 'Active').replace('false', 'Inactive')  ).join(SEPARATOR));

  const contents = [header].concat(rows).join('\n');
  const blob = new Blob([contents], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, fileName);
};

